import React from 'react'
import resolveLink from 'src/utils/resolveLink'
import Label from 'src/components/Label'
import Linkedin from "src/images/reskin/LinkedIn.svg"
import Facebook from "src/images/reskin/FaceBookSvg.svg"
import Email from "src/images/reskin/Email.svg"
import Twitter from "src/images/reskin/Twitter.svg"


const Share = ({currentUrl, title}) => {
    const url = resolveLink(currentUrl)
    return (
        <div className="lg:py-16 py-12">
            <Label className="text-darkblue !font-semibold text-sm text-center mx-auto" p={true}>Share</Label>
            <div className="flex flex-row items-center justify-center space-x-4 text-base  text-darkblue  p-2">
            <div className="flex flex-row items-center justify-center space-x-4 text-base max-w-[265px] text-darkblue border-2 border-[#D1D5DB] rounded-full p-2">
                <a
                    href={`http://www.facebook.com/sharer.php?u=https://cloudgateway.co.uk/${url}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Facebook/>
                    {/* <i class="fa-brands fa-facebook hover:text-brightgreen duration-300"></i> */}
                </a>
                <a
                    href={`https://twitter.com/share?url=https://cloudgateway.co.uk/${url}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Twitter/>

                    {/* <img src="/static/linkdin.png" class="fa-brands fa-twitter hover:text-brightgreen duration-300"/> */}
                </a>
                <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=https://cloudgateway.co.uk/${url}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Linkedin/>

                    {/* <i class="fa-brands fa-linkedin-in hover:text-brightgreen duration-300"></i> */}
                </a>
                <a
                    href={`mailto:?subject=${title}&body=Check out this article on Cloud Gateway: https://cloudgateway.co.uk/${url}`}
                >
                    <Email/>

                    {/* <i class="fa-regular fa-envelope hover:text-brightgreen duration-300"></i> */}
                </a>
            </div>
            </div>
            <hr className="border-lightblue-600 mt-16"/>
        </div>
    )
}

export default Share